// @flow
import * as React from 'react';

import Modal from 'app/common/components/Modal';

import AddChildForm from './AddChildForm';
import styles from './AddChild.scss';


type Props = {
  onClose: (e: SyntheticEvent<HTMLElement>) => void,
  isOpen: boolean,
}

const AddChild = ({ isOpen, onClose }: Props) =>
  <Modal isOpen={isOpen} close={onClose} className={styles.root}>
    <h2 className={styles.header}>Добавление ребенка</h2>
    <div className={styles.content}>
      <AddChildForm onClose={onClose} />
    </div>
  </Modal>;

export default AddChild;
